import { ValidationMessages } from "@libs/validation/validation.constants.ts";

export const messageWithData = (
  message: ValidationMessages,
  data: string | number
): ValidationMessages => {
  return message.replace("$(data)", data.toString()) as ValidationMessages;
};
